import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "formgrid grid" }
const _hoisted_3 = { class: "field col-12" }

import Panel from 'primevue/panel'

import {AxiosStatic} from "axios";
import {inject, ref} from "vue";
import {useRouter} from "vue-router";

import FileUpload, {
  FileUploadBeforeSendEvent,
  FileUploadBeforeUploadEvent,
  FileUploadSelectEvent,
  FileUploadUploadEvent
} from "primevue/fileupload";
import Keycloak from "keycloak-js";
import {useUserStore} from "@/stores/UserStore";

// Define component refs

export default /*#__PURE__*/_defineComponent({
  __name: 'ImportPayments',
  emits: ['newPayments'],
  setup(__props, { emit: emits }) {

const fileUpload = ref<FileUpload>()

// Define injects
const keycloak = inject<Keycloak>("keycloak")

// Define private properties
let fileName: (string | null) = null

// Define emits



// Define functions
function fileSelected(event: FileUploadSelectEvent) {
  if (event.files.length > 0) {
    fileName = event.files[0].name
  } else {
    fileName = null
  }
}

function uploadDone(response: FileUploadUploadEvent) {
  if (response.xhr.status == 204) {
    console.log('Import OK')
    emits('newPayments', {})
    fileUpload.value.clear()

  } else {
    console.error('Import failed!')
  }
}

function beforeSendHandler(event: FileUploadBeforeSendEvent) {
  event.xhr.setRequestHeader('Authorization', 'Bearer ' + keycloak?.token)
}

function beforeUploadHandler(event: FileUploadBeforeUploadEvent) {
  if (fileName != null) {
    event.formData.set("fileName", fileName)
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Panel), {
    header: "Import odchozích plateb",
    class: "mt-2 mb-2"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(FileUpload), {
              name: "file",
              ref_key: "fileUpload",
              ref: fileUpload,
              showUploadButton: true,
              showCancelButton: true,
              multiple: true,
              url: "/payment/import/outgoing-payments",
              onUpload: uploadDone,
              onSelect: fileSelected,
              onBeforeSend: beforeSendHandler,
              onBeforeUpload: beforeUploadHandler
            }, null, 512)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})